module.exports = __webpack_public_path__ + "static/media/football-ground.b00338cd.png";